import React from "react"
import styles from "./TrendArrow.module.css"

const TrendArrow = ({ positive }: { positive: boolean }) => (
  <svg
    className={`${styles.itemArrow} ${positive ? styles.positive : styles.negative}`}
    width="10"
    height="10"
    viewBox="0 0 20 20"
  >
    <rect x="0" y="0" width="20" height="20"></rect>
    <path
      d="M5.415,17.101l-1.487,-1.568l8.705,-9.187l-4.745,-0.003l-0.002,-2.057l8.18,0.007l0.006,8.632l-1.949,-0.002l-0.003,-5.008l-8.705,9.186Z"
      style={{
        transformOrigin: "10px 10px",
        transform: `rotate(${positive ? "0deg" : "90deg"})`,
      }}
    ></path>
  </svg>
)

export default TrendArrow
